import React, { type JSX } from 'react'

import { useChatTheme } from '@oneToOne/shared/components/chat/theme/useChatTheme'

import { useTwindContext } from '@core/twind'

import { chatHeaderContainer, chatHeaderTitle } from './ChatHeader.twind'

export interface ChatHeaderProps {
  title?: string
  actions?: JSX.Element
}

/**
 * Chat Header Component, has optional left and right actions
 */
export const ChatHeader: React.FC<ChatHeaderProps> = ({ title, actions }) => {
  const { theme } = useChatTheme()
  const { tw } = useTwindContext()

  return (
    <div
      className={tw?.(
        chatHeaderContainer({ theme }),
        'w-full',
        'flex',
        'justify-between',
        'items-center',
      )}
    >
      <div className={tw?.('flex', 'grow', 'w-1/2', 'justify-start')}>
        {title ? (
          <span className={tw?.(chatHeaderTitle, 'text-base ')}>{title}</span>
        ) : null}
      </div>
      <div className={tw?.('flex', 'grow', 'w-1/2', 'justify-end')}>
        {actions}
      </div>
    </div>
  )
}
